import { FC } from "react"

import { Flex, FlexItem } from "components/Flex"
import InlineControlsItem, { IInlineControlsItemProps } from "./InlineControlsItem"

interface IInlineControlsProps {
    items: IInlineControlsItemProps[]
}

const InlineControls: FC<IInlineControlsProps> = ({
    items,
}) => {
    if (!items.length) return null

    return (
        <Flex alignItems="center" wrap="wrap">
            {items.map((item, idx) => (
                <FlexItem key={idx}>
                    <InlineControlsItem
                        {...item}
                    />
                    {idx !== items.length - 1 &&
                        <span className="px-1">|</span>
                    }
                </FlexItem>
            ))}
        </Flex>
    )
}

export default InlineControls
